import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const More = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="more icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      d="M3.5 14.9557C4.88071 14.9557 6 13.8364 6 12.4557C6 11.075 4.88071 9.95569 3.5 9.95569C2.11929 9.95569 1 11.075 1 12.4557C1 13.8364 2.11929 14.9557 3.5 14.9557Z"
    />
    <path
      className={pathClass}
      d="M14.5 12.4557C14.5 13.8364 13.3807 14.9557 12 14.9557C10.6193 14.9557 9.5 13.8364 9.5 12.4557C9.5 11.075 10.6193 9.95569 12 9.95569C13.3807 9.95569 14.5 11.075 14.5 12.4557Z"
    />
    <path
      className={pathClass}
      d="M23 12.4557C23 13.8364 21.8807 14.9557 20.5 14.9557C19.1193 14.9557 18 13.8364 18 12.4557C18 11.075 19.1193 9.95569 20.5 9.95569C21.8807 9.95569 23 11.075 23 12.4557Z"
    />
  </svg>
)
